import NoSlotsAvailableSvg from '@assets/images/svg/no-slots-available.svg';
import React from 'react';
import { View } from 'react-native';

export interface NoSlotsAvailableIconProps {
  size?: number;
}

/** Figma empty time-slots illustration (calendar pop-out). Intrinsic 60×60. */
export function NoSlotsAvailableIcon({
  size = 60,
}: Readonly<NoSlotsAvailableIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <NoSlotsAvailableSvg width={size} height={size} />
    </View>
  );
}

export default NoSlotsAvailableIcon;
